import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { LoaderService } from './loader.service';
import { LoadingSpinnerComponent } from './loading-spinner.component';

@Directive({
  selector: '[appLoading]',
  standalone: false,
})
export class LoadingDirective implements OnInit, OnDestroy {
  private readonly destroy$: Subject<void> = new Subject();
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly loaderService: LoaderService,
  ) {}

  public ngOnInit(): void {
    this.loaderService.isLoading$
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((isLoading: boolean) => (isLoading ? this.showLoader() : this.hideLoader()));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private showLoader(): void {
    this.viewContainerRef.clear();
    this.viewContainerRef.createComponent(LoadingSpinnerComponent);
  }

  private hideLoader(): void {
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }
}
